import { TextField } from '@xbotvn/mui';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, {
  useCallback,
  useState,
} from 'react';

export default function Scanner({
  value: valueProp = '',
  inputRef = {},
  onChange = () => { },
  ...props
}) {
  const [valueState, setValueState] = useState();

  const value = valueState !== undefined ? valueState : valueProp;

  const onChangeDebounce = useCallback(debounce(onChange, 500), []);

  const onChangeLocal = (event) => {
    setValueState(event.target.value);
    onChangeDebounce(event.target.value);
  };

  return (
    <TextField
      placeholder="Mã sách"
      ref={inputRef}
      value={value}
      onChange={onChangeLocal}
      {...props}
    />
  );
}

Scanner.propTypes = {
  inputRef: PropTypes.shape(),
  value: PropTypes.string,
  onChange: PropTypes.func,
};
